@use "~theme/breakpoints";

.card {
  @include breakpoints.desktop {
    margin: 0 auto;
    max-width: var(--max-desktop-width);
  }
}
